import styled from '@emotion/styled';
import H3 from '@base/H3/H3';
import { Spacings, breakpoints } from '@styles/index';
import P1 from '@base/P1/P1';
import Divider from '@base/Divider/Divider';
import UnderlineLink from '@comp/UnderlineLink/UnderlineLink';
import { segment } from '@actions/analytics';
import { getImage } from '@utils/imageHelper';
import { LOGIN_STARTED } from '@cont/Login/constants';
import { useToggleable } from '@stores/toggleables';
import { LOGIN_DRAWER } from '@constants/toggleables';

const UnAuthorizedImg = styled.img`
  margin: ${Spacings.SPACING_13B} auto ${Spacings.SPACING_8B};
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin: ${Spacings.SPACING_8B} auto ${Spacings.SPACING_8B};
  }
`;

const StyH3 = styled(H3)`
  margin: 0 auto ${Spacings.SPACING_8B};
  text-align: center;
`;

const StyDivider = styled(Divider)`
  margin-bottom: ${Spacings.SPACING_10B};
`;

const StyP1 = styled(P1)`
  text-align: center;
  margin-bottom: ${Spacings.SPACING_1B};
`;

const LinkText = styled(P1)`
  color: var(--color-i-blue);
`;

const StyUnderlineLink = styled(UnderlineLink)`
  margin: 0 auto;
`;

const UnAuthorized = () => {
  const { openElement: openLoginDrawer } = useToggleable(LOGIN_DRAWER);

  const login = () => {
    segment.track(LOGIN_STARTED);
    openLoginDrawer();
  };

  return (
    <>
      <UnAuthorizedImg
        src={getImage('physical-notes/unauthorized.svg')}
        width={Spacings.SPACING_25B}
        alt="unauthorized"
      />
      <StyH3>You’re not authorised to avail this offer</StyH3>
      <StyDivider />
      <StyP1>Not you? </StyP1>
      <StyUnderlineLink href="#" color="var(--color-i-blue)" onClick={login}>
        <LinkText>Log-in as another user</LinkText>
      </StyUnderlineLink>
    </>
  );
};

export default UnAuthorized;
